
import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set up scroll event listener with passive option for performance
  useEffect(() => {
    const handleScroll = () => {
      toggleVisibility();
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="fixed bottom-20 right-6 z-50">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="bg-brand-red/80 hover:bg-brand-red text-white rounded-full p-2 shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-brand-red focus:ring-offset-2"
          aria-label="Naar boven scrollen"
          title="Naar boven scrollen"
        >
          <ChevronUp size={20} aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
